import { jsonApi } from '../jsonApi';

jsonApi.define('tms/tag-template-editor', {
  label: '',
});
